const Routes = {
  base: '/',
  start: '/start',
  addOns: '/addOns',
  overview: '/overview',
  purchase: '/purchase',
  review: '/review',
};

export default Routes;
